import BaseClient from '../base/baseClient';
import endpoints from '../../features/endPoints/paymentEndpoints';

const GetAccessToken = async (body, customerNumber) => {
  const paymetricAPIURL = process.env.REACT_APP_Paymetric_URL;
  const { get: getPaymentClient } = BaseClient();
  return getPaymentClient(paymetricAPIURL+endpoints.accessToken(body, customerNumber));
};

const GetPaymentToken = (body,customerNumber,amount, zipcode) => {
  const paymetricAPIURL = process.env.REACT_APP_Paymetric_URL;
  const { get: getPaymentClient } = BaseClient();
  
  return getPaymentClient(paymetricAPIURL+endpoints.paymentToken(body,customerNumber,amount,zipcode), {},true, mapPaymentTokenResponse);
};

//map response to object needed by React view
const mapPaymentTokenResponse = (response) => {
  let mappedData = {};
  response.data.map(b => {
    mappedData[b.Name] = b.Value;
  });
  
  mappedData.isCreditCard = response.data.length === 5;
  mappedData.isAccount = response.data.length === 4 || response.data.length === 3;
  
  if(mappedData.isCreditCard) {
    let cashSubType = '';
    switch(mappedData['Card Type']){
    case 'mc':
      cashSubType = 'MCD';
      break;
    case 'vi':
      cashSubType = 'VIS';
      break;
    case 'ax':
      cashSubType = 'AMX';
      break;
    case 'di':
      cashSubType = 'DCV';
      break;
    default:
      cashSubType = '';
    }
    mappedData.cashSubType = cashSubType;
  }

  if(mappedData['Expiration Month'] && mappedData['Expiration Month'].length === 1) {
    mappedData['Expiration Month'] = '0' + mappedData['Expiration Month'];
  }

  mappedData.tokenNum = mappedData.isCreditCard ? mappedData['Card Number'] : mappedData['Account Number'];

  response.rawData = response.data;
  response.data = mappedData;
  return response;
};

export {
  GetAccessToken,
  GetPaymentToken
};
